import * as svg from "../../../assets/three-dot-vertical-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const ThreeDotVerticalIcon = iconBuilder(svg, "ThreeDotVerticalIcon", "0 0 16 17");
